<script>
import { mapState, mapActions } from 'vuex';
import TwConfirmDialog from '../TwConfirmDialog';
import escapable from '../../mixins/escapable';

export default {
  name: 'AffiliatesDomains',
  components: {
    TwConfirmDialog,
  },
  mixins: [
    escapable,
  ],
  data() {
    return {
      headers: [
        { value: 'domain', text: 'Domain' },
        { value: 'suppliers', text: 'Suppliers' },
        { value: 'logo', text: 'Logo', width: '50px' },
        { value: 'delete', text: 'Delete', sortable: false, width: '50px' },
      ],
      newDomainShow: false,
      domainIdToRemove: undefined,
      chosenDomain: undefined,
      snackbarText: undefined,
      snackbarShow: false,
      pagination: {
        rowsPerPage: 10,
      },
    };
  },
  computed: {
    ...mapState({
      affiliate: state => state.affiliates.affiliate.item,
      error: state => state.affiliates.affiliate.error,
      domains: state => state.affiliates.domains,
    }),
    availableDomains() {
      return this.domains.items.filter(
        domain => this.affiliate.domains.findIndex(d => d.domainId === domain.id) === -1,
      );
    },
  },
  methods: {
    ...mapActions({
      syncDomains: 'affiliates/syncDomains',
    }),
    addDomain() {
      const domainIds = this.affiliate.domains.map(d => d.domainId);
      domainIds.push(this.chosenDomain);
      this.newDomainShow = false;
      this.syncDomains(domainIds).then(() => {
        if (this.error) {
          this.snackbarText = 'Unable to sync the affiliate domains';
          this.snackbarShow = true;
        }
      });
    },
    removeDomain(domainId) {
      this.domainIdToRemove = domainId;
      this.$refs.confirm.open();
    },
    confirmRemoveDomain() {
      const domainIds = this.affiliate.domains
        .filter(d => d.domainId !== this.domainIdToRemove)
        .map(d => d.domainId);
      this.syncDomains(domainIds).then(() => {
        if (this.error) {
          this.snackbarText = 'Unable to sync the affiliate domains';
          this.snackbarShow = true;
        }
      });
      this.cancelRemoveDomain();
    },
    cancelRemoveDomain() {
      this.domainIdToRemove = undefined;
    },
    openNewDomain() {
      this.newDomainShow = true;
      // Waiting for transition
      setTimeout(() => {
        this.$refs.newDomain.focus();
      }, 350);
    },
    escapeHandler() {
      this.newDomainShow = false;
    },
  },
};
</script>

<template>
  <v-flex v-if="affiliate" xs12>
    <v-layout wrap mt-4>
      <v-flex xs12 mt-4 mb-2>
        <span class="title">Domains</span>
      </v-flex>
      <v-flex xs12>
        <v-divider/>
      </v-flex>
      <v-flex xs12>
        <v-data-table
          :items="affiliate.domains"
          :headers="headers"
          :pagination.sync="pagination"
        >
          <template v-slot:items="props">
            <tr>
              <td>{{ props.item.domain.name }}</td>
              <td>{{ props.item.affiliateDomainSuppliers.length }}</td>
              <td>
                <v-icon v-if="props.item.logo" color="green">check</v-icon>
                <v-icon v-else color="red">clear</v-icon>
              </td>
              <td>
                <v-btn small icon @click="removeDomain(props.item.domainId)">
                  <v-icon small>delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:footer>
            <td :colspan="headers.length" class="text-xs-center">
              <v-btn icon @click="openNewDomain">
                <v-icon class="grey--text">add</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
        <v-dialog
          v-model="newDomainShow"
          max-width="400px"
          persistent
          no-click-animation
        >
          <v-card>
            <v-card-title>
              <h1>Add new domain</h1>
              <v-spacer/>
              <v-btn icon small @click="newDomainShow = false">
                <v-icon small>close</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider/>
            <v-card-text>
              <v-autocomplete
                v-model="chosenDomain"
                :items="availableDomains"
                placeholder="Select domain"
                item-text="name"
                item-value="id"
                ref="newDomain"
                clearable
              />
            </v-card-text>
            <v-card-actions>
              <v-spacer/>
              <v-btn :disabled="!chosenDomain" color="info" @click="addDomain">
                Add
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <tw-confirm-dialog
        ref="confirm"
        title="Are you sure?"
        description="Removing any domains will remove any associated data"
        @confirm="confirmRemoveDomain"
        @cancel="cancelRemoveDomain"
      />
      <v-snackbar v-model="snackbarShow">{{ snackbarText }}</v-snackbar>
    </v-layout>
  </v-flex>
</template>



// WEBPACK FOOTER //
// src/components/Affiliates/AffiliatesDomains.vue